// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__BWLer","social":"Header_social__4TTl0"};